// какая-то вспомогательная фукнция - без неё не работает collapse
export function reflow(element) {
    return element.offsetHeight
}
